import React, {createContext, useState} from 'react';
import {Snackbar} from "@mui/material";
import { Alert } from '@mui/material';

export const NotificationContext = createContext();

const NotificationContextProvider = (props) => {

    const [notificationMessage, setNotificationMessage] = useState('');
    const [type, setType] = useState('success');
    const [open, setOpen] = useState(false);
    const showMessage = (message, messageType) => {
        setNotificationMessage(message);
        if (messageType !== undefined) {
            setType(messageType);
        } else {
            setType('success');
        }
        setOpen(true);
    }

    const showError = (message) => {
        setNotificationMessage(message);
        setType('error');
        setOpen(true);
    }


    return (
        <NotificationContext.Provider value={{showMessage, showError}}>
            {props.children}
            <Snackbar
                xs={{width: '100%'}}
                open={open}
                autoHideDuration={4500}
                onClose={() => {setOpen(false);setNotificationMessage('');setType('success')}}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                key={'bottom-right'}
            >             
                <Alert severity={type} sx={{width: '100%'}}>
                    <b>{notificationMessage}</b>
                </Alert>
            </Snackbar>
        </NotificationContext.Provider>

    );
};

export default NotificationContextProvider;